<template>
    <div class="modal-content">
        <div class="modal-contentWrap">
            <div class="modal-header bg-1">
                <modal-close />
                <div class="modal-title text-center mb-0 mb-md-2">
                    <h2 class="h3 mb-1 mt-2">
                        Załączniki do grupy promocji ({{
                            modalArgs.groupAttachments.length
                        }}
                        szt.)
                    </h2>
                    <div>{{ modalArgs.name }}</div>
                </div>
            </div>
            <div class="modal-body px-2 py-4 px-sm-4">
                <div class="no-expanded-slider">
                    <promotion-slider
                        :data="setGroupAttachmentsData"
                        :responsive="{
                            120: {
                                items: 1.2
                            },
                            320: {
                                items: 1.2
                            },
                            520: {
                                items: 2.2
                            },
                            768: {
                                items: 2.2
                            },
                            992: {
                                items: 3.2
                            },
                            1200: {
                                items: 4.2
                            }
                        }"
                        :show-download-btn="true"
                    />
                </div>
            </div>
            <div
                class="modal-footer flex-wrap flex-sm-nowrap"
                style="position: sticky; bottom: 0; background: white"
            >
                <the-btn
                    class="btn-outline-custom btn-block my-0 mb-sm-0 mb-2"
                    text="Powrót"
                    @click.native="$store.dispatch('toggleModal', false)"
                />
                <the-btn
                    class="btn-block my-0"
                    text="Pobierz wszystkie załączniki"
                    icon="Download"
                    :loading-status="$store.getters.getAllGroupAttachmentsStatus"
                    @click.native="downloadAllGroupAttachments"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PromotionSlider from '@/components/promotions/PromotionSlider'

export default {
    name: 'DownloadGroupAttachments',
    components: {
        PromotionSlider
    },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        downloadAllGroupAttachments() {
            this.$store.dispatch('downloadAllGroupAttachments', {
                promo_group_id: this.modalArgs.groupId,
                name: this.modalArgs.name,
                status: 'active',
                includes: 'attachment'
            })
        }
    },
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },
        setGroupAttachmentsData() {
            return this.modalArgs.groupAttachments.map(e => {
                return {
                    urls: {
                        original: e.attachment.urls.original
                    },
                    fileName: e.attachment.name,
                    name: e.attachment.name,
                    id: e.id
                }
            })
        }
    }
}
</script>
